(ns common.schema.field-type)

(def field-types
  {:field.type/boolean        {:data-type    :data.type/boolean
                               :translations {:en "Boolean"}
                               :field-prefix "bool-"}
   :field.type/integer        {:data-type    :data.type/integer
                               :translations {:en "Integer"}
                               :field-prefix "int-"}
   :field.type/number         {:data-type    :data.type/number
                               :translations {:en "Decimal number"}
                               :field-prefix "num-"}
   :field.type/text-short     {:data-type    :data.type/text-simple
                               :translations {:en "Text - short"}
                               :field-prefix "txt-"}
   :field.type/text-multiline {:data-type    :data.type/text-multiline
                               :translations {:en "Text - multiline"}
                               :field-prefix "txt-lines-"}
   :field.type/option-single  {:data-type    :data.type/ref-single
                               :translations {:en "Option - single"}
                               :field-prefix "opt-"}
   :field.type/option-multi   {:data-type    :data.type/ref-multi
                               :translations {:en "Option - multi"}
                               :field-prefix "opts-"}
   :field.type/date           {:data-type    :data.type/date
                               :translations {:en "Date"}
                               :field-prefix "date-"}
   :field.type/datetime       {:data-type    :data.type/datetime
                               :translations {:en "Timestamp"}
                               :field-prefix "ts-"}
   :field.type/percentage     {:data-type    :data.type/percentage
                               :translations {:en "Percentage"}
                               :field-prefix "per-"}
   :field.type/currency       {:data-type    :data.type/currency-value
                               :translations {:en "Currency"}
                               :field-prefix "cur-"}
   :field.type/multiplier     {:data-type    :data.type/multiplier
                               :translations {:en "Multiplier"}
                               :field-prefix "mul-"}
   :field.type/email          {:data-type    :data.type/email
                               :translations {:en "Email"}
                               :field-prefix "email-"}
   :field.type/url            {:data-type    :data.type/text-url
                               :translations {:en "Url"}
                               :field-prefix "url-"}})

(def field-options
  (->> field-types
       (map (fn [[k i]]
              [k
               (->> i
                    :translations
                    :en)]))
       (into {})))
